// extracted by mini-css-extract-plugin
export default {"icon":"RjNIP7HcwjY_Kgov1pR7"};